import {css, html, LitElement} from 'lit';
import {customElement, property} from 'lit/decorators';
import {
  containerStyles,
  moduleSpacingStyles,
  normalizeStyles,
  typographyStyles
} from "@webs/components-library/theming";

@customElement('webs-form-box')
export class FormBox extends LitElement {
  static styles = [
    normalizeStyles,
    moduleSpacingStyles,
    containerStyles,
    typographyStyles,
    css`
      .box {
        background: var(--color-white);
        border-radius: .8rem;
        box-shadow: 8px 0px 50px rgba(24, 26, 35, 0.08);
        padding: 2.8rem 2rem;
      }

      .box h3 {
        margin-bottom: 1.6rem;
      }

      @media only screen and (min-width: 992px) {
        .box h3 {
          margin-bottom: 2rem;
        }
      }
    `,
  ];
  @property()
  title: string;

  protected render(): unknown {
    return html`
      <div class="box">
        <h3>${this.title}</h3>
        <slot></slot>
      </div>
    `
  }
}
